import { z } from 'zod'

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  itemId: z.number(),
  lotNo: z.string(),
  unit: z.string(),
  qty: z.number(),
})

export const Inv2310GetResultSchema = z.object({
  number: z.string(),
  date: z.string(),
  partyId: z.number(),
  refNo: z.string(),
  refDate: z.string(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
})

export type Inv2310GetResultModel = z.input<typeof Inv2310GetResultSchema>
